<template>
    <div id="documents" class="clearfix gibson px2 mb4">
        <div class="clearfix" v-if="loading">
          <Loading></Loading>
        </div>
        <div class="col-12" v-else>
            <div class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3">Filer</p>
            </div>
            <!-- Search -->
            <div class="flex mb3">
              <div class="col-8 flex pr2 pl0">
                <el-input
                  placeholder="Skriv noget"
                  prefix-icon="el-icon-search"
                  class="flex"
                  v-model="searchQuery">
                </el-input>
              </div>
              <div class="col-2 px2">
                <button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="showCreateFolder()">
                  Opret mappe
                </button>
              </div>
              <div class="col-2 px2">
                <button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="showAddFileForm()">
                  Upload fil
                </button>
              </div>
            </div>
            <div class="mb3">
              <ol class="breadcrumb border-none transparent px0 mb-0">
                <li class="h6 breadcrumb-item pointer" v-for="(folder, index) in parentFolderData" :key="index" @click="folderChange(folder.folderId, folder.folderName, currentFolderParentId, index, 'out')">
                  <a>{{folder.folderName}}</a>
                </li>
              </ol>
            </div>
            <!-- Recent and actions -->
            <div class="flex mb3">
              <i class="el-icon-time mr1"></i>
              <p class="m0">Nylig</p>
            </div>
            <div class="flex flex-wrap">
              <div class="col-9 mb3">
                <div class="flex mb3">
                  <!--  eslint-disable -->
                  <div class="pointer col-3 flex border p2 mr1" v-for="(docs, index) in documentsData" :key="index" @click="filterFile(docs.NAME)" v-if="index <= 3">
                    <div v-if="docs.TYPE == 'folder'">
                      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 26.443 22.744">
                        <g id="Group_3157" data-name="Group 3157" transform="translate(1313.87 -105.256)">
                          <path id="Path_1013" data-name="Path 1013" d="M.969.516H0A.581.581,0,0,1-.5.008.581.581,0,0,1,0-.5H.969a.552.552,0,0,1,.469.508A.552.552,0,0,1,.969.516Z" transform="translate(-1295.703 107.953)" fill="#fe9444"/>
                          <path id="Path_1013-2" data-name="Path 1013" d="M787.936,198.609V183.245c0-1.014-.721-1.17-1.773-1.17h-3.519a1.007,1.007,0,0,0-.254.013.379.379,0,0,0,.038.746,1.766,1.766,0,0,0,.255.006H786.3c.638,0,.864.222.864.851q0,7.235,0,14.47c0,.042,0,.085,0,.128-.008.291-.132.423-.418.43-.187,0-.377-.017-.562,0-.224.024-.278-.048-.278-.274q.012-5.946.006-11.892a2.2,2.2,0,0,0-.054-.608,1.434,1.434,0,0,0-1.512-1.041c-3.767,0-7.535-.012-11.3.008a1.958,1.958,0,0,1-1.868-.993,2.385,2.385,0,0,0-2.22-1.2c-1.4.013-2.8,0-4.194.007-.171,0-.248-.034-.231-.221s0-.357,0-.536a1.178,1.178,0,0,1,1.322-1.321l5.114,0a2.313,2.313,0,0,1,.606.071,1.909,1.909,0,0,1,1.091.941,2.408,2.408,0,0,0,2.185,1.172c1.364-.009,1.728,0,3.091,0a1.661,1.661,0,0,0,.179,0,.36.36,0,0,0,.353-.368.365.365,0,0,0-.332-.388,1.243,1.243,0,0,0-.23-.006h-3.142a1.625,1.625,0,0,1-1.406-.738c-.083-.119-.16-.24-.242-.36a2.3,2.3,0,0,0-1.953-1.076q-2.748-.028-5.5,0a1.9,1.9,0,0,0-1.865,1.521,5.012,5.012,0,0,0-.037,1.095c0,.159-.034.224-.209.224a1.573,1.573,0,0,0-1.734,1.351l-.041,17.082c0,.8.733,1.132,1.524,1.138q.7.005,1.406,0c.31,0,.469-.136.469-.381s-.163-.379-.471-.383c-.426,0-.852,0-1.278,0-.681,0-.926-.242-.926-.915q0-7.91-.008-15.821c0-1.025.46-1.341,1.333-1.324q2.479.048,4.96,0a1.9,1.9,0,0,1,1.826.971,2.453,2.453,0,0,0,2.287,1.222c2.8-.012,5.591,0,8.386,0,1.023,0,2.045,0,3.068,0a.739.739,0,0,1,.638.252.91.91,0,0,1,.142.607q0,7.209,0,14.417c0,.524-.085.61-.606.61l-14.964-.009a1.718,1.718,0,0,0-.305.014.369.369,0,0,0-.277.507c.092.217.282.245.489.245,5.983,0,9.237.007,15.22.007a1.137,1.137,0,0,0,1.21-1.2c.007-.349,0-.7,0-1.046,0-.593-.023-.591.589-.591C787.668,199.488,787.936,199.029,787.936,198.609Z" transform="translate(-2075.513 -74.478)" fill="#fe9444" stroke="#fe9444" stroke-width="0.3"/>
                          <path id="Path_1014" data-name="Path 1014" d="M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z" transform="translate(-1309 127)" fill="#fe9444"/>
                        </g>
                      </svg>
                    </div>
                    <div v-else-if="docs.NAME.includes('png') || docs.NAME.includes('jpg') || docs.NAME.includes('jpeg') || docs.NAME.includes('JPG') || docs.NAME.includes('PNG')">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="rgba(77, 207, 85, 1.0)" viewBox="0 0 512 512" width="35" height="35"><path d="M374 108H154.9l150.1-86.7c4.8-2.8 10.9-1.1 13.7 3.7l33.9 58.7c2.8 4.8 8.9 6.4 13.7 3.7 4.8-2.8 6.4-8.9 3.7-13.7l-33.9-58.7c-8.3-14.3-26.7-19.2-41-11L115.1 107.9c-0.1 0-0.1 0.1-0.2 0.1H30C13.5 108 0 121.5 0 138v344C0 498.5 13.5 512 30 512h344c16.5 0 30-13.5 30-30V138C404 121.5 390.5 108 374 108zM384 482c0 5.5-4.5 10-10 10H30c-5.5 0-10-4.5-10-10V138c0-5.5 4.5-10 10-10h344c5.5 0 10 4.5 10 10V482z"/><path d="M447.3 208.5c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C450.2 212.9 449.2 210.4 447.3 208.5z"/><path d="M508 312.9l-41.4-71.7c-2.8-4.8-8.9-6.4-13.7-3.7 -4.8 2.8-6.4 8.9-3.7 13.7l41.4 71.7c2.8 4.8 1.1 10.9-3.7 13.7l-64.3 37.1c-4.8 2.8-6.4 8.9-3.7 13.7 1.9 3.2 5.2 5 8.7 5 1.7 0 3.4-0.4 5-1.3l64.3-37.1C511.3 345.6 516.3 327.2 508 312.9z"/><path d="M263.1 158.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1s1.1 5.2 2.9 7.1 4.4 2.9 7.1 2.9c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1S264.9 160.8 263.1 158.9z"/><path d="M346 156h-39c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h29v142.6l-79.4-79.4c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-53 53c-3.9 3.9-3.9 10.2 0 14.1 3.9 3.9 10.2 3.9 14.1 0l45.9-45.9 86.4 86.4c0 0 0 0 0.1 0.1v49.2H82.1l72.6-72.6 53.9 53.9c3.9 3.9 10.2 3.9 14.1 0 3.9-3.9 3.9-10.2 0-14.1l-61-61c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-79.7 79.7V176h134c5.5 0 10-4.5 10-10 0-5.5-4.5-10-10-10H58c-5.5 0-10 4.5-10 10v240c0 5.5 4.5 10 10 10h288c5.5 0 10-4.5 10-10V166C356 160.5 351.5 156 346 156z"/><path d="M145.7 199c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32S163.3 199 145.7 199zM145.7 243c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12C157.7 237.6 152.3 243 145.7 243z"/></svg>
                    </div>
                    <div v-else-if="docs.NAME.includes('pdf')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 41.904 44.79">
                        <g id="pdf" transform="translate(0)">
                          <path id="Path_937" data-name="Path 937" d="M180.34,394.293H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0" transform="translate(-147.193 -359.8)" fill="#e34856"/>
                          <path id="Path_938" data-name="Path 938" d="M180.34,341.215H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0" transform="translate(-147.193 -311.365)" fill="#e34856"/>
                          <path id="Path_939" data-name="Path 939" d="M161.3,288.766a.661.661,0,0,0,.661.661h11.693a.661.661,0,1,0,0-1.322H161.966A.661.661,0,0,0,161.3,288.766Zm0,0" transform="translate(-147.194 -262.902)" fill="#e34856"/>
                          <path id="Path_940" data-name="Path 940" d="M40.124,8.672,38.932,7.378V2.751A2.758,2.758,0,0,0,36.173,0H6.6A2.758,2.758,0,0,0,3.845,2.751V7.971H2.636A2.639,2.639,0,0,0,0,10.608v8a2.639,2.639,0,0,0,2.636,2.637H3.845V39.689A2.758,2.758,0,0,0,6.6,42.44h1.51a2.683,2.683,0,0,0,2.659,2.35H39.221A2.684,2.684,0,0,0,41.9,42.111V13.555c0-2.337-.07-3.025-1.78-4.883Zm.43,3.523H35.6a1.36,1.36,0,0,1-1.36-1.356l0-5.749c.869.065,1.1.322,1.863,1.169.126.141.264.294.418.461l1.264,1.372.014.015,1.346,1.462c1.05,1.141,1.329,1.62,1.4,2.628ZM5.167,2.751A1.435,1.435,0,0,1,6.6,1.322H36.173A1.435,1.435,0,0,1,37.61,2.751V5.943l-.11-.12c-.15-.162-.284-.312-.407-.449a3.683,3.683,0,0,0-3.507-1.626H10.774a2.683,2.683,0,0,0-2.68,2.679V7.971H5.167Zm35.415,39.36a1.36,1.36,0,0,1-1.36,1.357H10.774a1.359,1.359,0,0,1-1.358-1.357v-9.58a.661.661,0,0,0-1.322,0v8.586H6.6a1.435,1.435,0,0,1-1.437-1.429V21.248H8.093V29.5a.661.661,0,0,0,1.322,0V21.248h3.432a.661.661,0,0,0,0-1.322H2.635A1.316,1.316,0,0,1,1.322,18.61v-8A1.316,1.316,0,0,1,2.635,9.293h17.41a1.317,1.317,0,0,1,1.316,1.315v8a1.317,1.317,0,0,1-1.316,1.315H15.876a.661.661,0,1,0,0,1.322h4.169a2.641,2.641,0,0,0,2.638-2.637v-8a2.641,2.641,0,0,0-2.638-2.637H9.416V6.428a1.359,1.359,0,0,1,1.358-1.357h22.15l0,5.768A2.684,2.684,0,0,0,35.6,13.517h4.98V42.111Zm0,0" fill="#e34856"/>
                          <path id="Path_941" data-name="Path 941" d="M51.83,134.637H50.247a.674.674,0,0,0-.5.2.684.684,0,0,0-.2.5v4.682a.668.668,0,0,0,.2.491.675.675,0,0,0,1.15-.475v-1.358h1.017a2.013,2.013,0,0,0,1.483-.554,2.152,2.152,0,0,0-.033-2.928,2.127,2.127,0,0,0-1.534-.567Zm.492,2.624a.775.775,0,0,1-.567.242H50.9v-1.658h.867a.75.75,0,0,1,.571.246.842.842,0,0,1,.229.6A.784.784,0,0,1,52.322,137.261Zm0,0" transform="translate(-45.213 -122.859)" fill="#e34856"/>
                          <path id="Path_942" data-name="Path 942" d="M112.9,136.312a2.606,2.606,0,0,0-.829-1.037,3.172,3.172,0,0,0-1.917-.541h-1.392a.655.655,0,0,0-.492.208.667.667,0,0,0-.2.475v4.64a.665.665,0,0,0,.192.491.741.741,0,0,0,.508.183h1.5a2.811,2.811,0,0,0,1.95-.658,3.041,3.041,0,0,0,.975-2.357,3.331,3.331,0,0,0-.3-1.4Zm-1.529,2.712a1.458,1.458,0,0,1-1.15.491h-.8v-3.557h.725a1.583,1.583,0,0,1,1.213.475,1.8,1.8,0,0,1,.446,1.283,1.906,1.906,0,0,1-.433,1.308Zm0,0" transform="translate(-98.612 -122.947)" fill="#e34856"/>
                          <path id="Path_943" data-name="Path 943" d="M177.273,140.739a.646.646,0,0,0,.479-.2.655.655,0,0,0,.2-.475v-1.791h1.284a.628.628,0,0,0,.458-.179.6.6,0,0,0,0-.866.634.634,0,0,0-.454-.179h-1.284v-1.175h1.517a.574.574,0,0,0,.433-.183.6.6,0,0,0,.175-.425.6.6,0,0,0-.179-.446.585.585,0,0,0-.429-.179h-2.184a.655.655,0,0,0-.492.208.677.677,0,0,0-.2.483v4.731a.635.635,0,0,0,.208.475.668.668,0,0,0,.475.2Zm0,0" transform="translate(-161.141 -122.862)" fill="#e34856"/>
                        </g>
                      </svg>
                    </div>
                    <p class="px1 m0">{{docs.NAME}}</p>
                  </div>
                  <!--  eslint-enable -->
                </div>
                <p>{{resultQuery.length}} filer</p>
              </div>
              <div class="col-3">
                <div class="block border p2">
                  <div class="cyprus light flex justify-between mb2">
                    <span>Brugt</span>
                    <span>Ledig</span>
                  </div>
                  <el-progress :show-text=false :percentage="20" :max="100" class="my2" :color="customColorMethod(20)"></el-progress>
                  <div class="flex justify-between mb3">
                    <span class="h5 semi-bold darkblue">{{totalSize}}</span>
                    <span class="darkblue"><i class="fas fa-infinity"></i></span>
                  </div>
                  <div v-if="bulkActionVisible">
                    <!-- Duplicate -->
                    <el-button class="border-none regular p1 transparent-button flex" @click="loopCopyFile('multiple', [])">
                      <div class="flex">
                        <div class="mr1">
                          <svg xmlns="http://www.w3.org/2000/svg" id="document" width="28.885" height="34.234" viewBox="0 0 28.885 34.234">
                            <path id="Path_42" data-name="Path 42" d="M26.879,0H8.157A2.008,2.008,0,0,0,6.151,2.006V3.744H2.006A2.008,2.008,0,0,0,0,5.75V28.389H0a.666.666,0,0,0,.194.471l5.176,5.176a.669.669,0,0,0,.473.2H20.727a2.008,2.008,0,0,0,2.006-2.006V30.489h4.145a2.008,2.008,0,0,0,2.006-2.006V20.126a.669.669,0,0,0-1.337,0v8.358a.669.669,0,0,1-.669.669H22.733V25.283h1.975a.669.669,0,1,0,0-1.337H22.733V21.539h1.975a.669.669,0,0,0,0-1.337H22.733V17.794h1.975a.669.669,0,0,0,0-1.337H22.733V14.05h1.975a.669.669,0,0,0,0-1.337H22.733V10.3h1.975a.669.669,0,0,0,0-1.337H22.733V5.75a2,2,0,0,0-.115-.669h4.929v9.026a.669.669,0,0,0,1.337,0V2.006A2.008,2.008,0,0,0,26.879,0ZM5.176,31.951,2.283,29.058H4.235A.942.942,0,0,1,5.176,30Zm16.22.277a.669.669,0,0,1-.669.669H6.513V30A2.28,2.28,0,0,0,4.235,27.72h-2.9V8.826H21.4v.809h0v3.744h0v3.742h0V20.87h0Zm0-26.478V7.489H1.337V5.75a.669.669,0,0,1,.669-.669H20.727A.669.669,0,0,1,21.4,5.75Zm-.669-2.006H7.489V2.006a.669.669,0,0,1,.669-.669H26.879a.669.669,0,0,1,.669.669V3.744Zm0,0" fill="#19a3c0"/>
                            <path id="Path_43" data-name="Path 43" d="M66.7,358.02H52.259a.669.669,0,1,0,0,1.337H66.7a.669.669,0,1,0,0-1.337Zm0,0" transform="translate(-48.141 -334.082)" fill="#19a3c0"/>
                            <path id="Path_44" data-name="Path 44" d="M174.394,414.012h-6.726a.669.669,0,1,0,0,1.337h6.726a.669.669,0,1,0,0-1.337Zm0,0" transform="translate(-155.834 -386.33)" fill="#19a3c0"/>
                            <path id="Path_45" data-name="Path 45" d="M52.258,303.337H62.491a.669.669,0,1,0,0-1.337H52.258a.669.669,0,0,0,0,1.337Zm0,0" transform="translate(-48.14 -281.808)" fill="#19a3c0"/>
                            <path id="Path_46" data-name="Path 46" d="M66.7,246.012H52.259a.669.669,0,0,0,0,1.337H66.7a.669.669,0,1,0,0-1.337Zm0,0" transform="translate(-48.141 -229.563)" fill="#19a3c0"/>
                            <path id="Path_47" data-name="Path 47" d="M52.258,191.325h5.049a.669.669,0,0,0,0-1.337H52.258a.669.669,0,0,0,0,1.337Zm0,0" transform="translate(-48.14 -177.285)" fill="#19a3c0"/>
                            <path id="Path_48" data-name="Path 48" d="M185.366,189.988h-5.939a.669.669,0,1,0,0,1.337h5.939a.669.669,0,1,0,0-1.337Zm0,0" transform="translate(-166.806 -177.285)" fill="#19a3c0"/>
                            <path id="Path_49" data-name="Path 49" d="M252.964,302h-1.1a.669.669,0,0,0,0,1.337h1.1a.669.669,0,0,0,0-1.337Zm0,0" transform="translate(-234.404 -281.808)" fill="#19a3c0"/>
                            <path id="Path_50" data-name="Path 50" d="M412.669,246a.669.669,0,1,0,.473.2A.674.674,0,0,0,412.669,246Zm0,0" transform="translate(-384.453 -229.552)" fill="#19a3c0"/>
                          </svg>
                        </div>
                        Duplicate
                      </div>
                    </el-button>
                    <!-- Rename -->
                    <el-button class="border-none regular p1 transparent-button flex" @click="showRenameFile('multiple', [])">
                      <div class="flex">
                        <div class="mr1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="28.5" height="27.42" viewBox="0 0 28.5 27.42">
                            <g id="Edit" transform="translate(-3.75 -3.33)">
                              <path id="Path_1016" data-name="Path 1016" d="M18,30H31.5" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                              <path id="Path_1017" data-name="Path 1017" d="M24.75,5.25a3.182,3.182,0,0,1,4.5,4.5L10.5,28.5,4.5,30,6,24Z" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                            </g>
                          </svg>
                        </div>
                        Rename
                      </div>
                    </el-button>
                    <!-- Delete -->
                    <el-button class="border-none regular p1 transparent-button flex" @click="confirmDelete('multiple', null, null)">
                      <div class="flex">
                        <div class="mr1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="28.5" height="31.5" viewBox="0 0 28.5 31.5">
                            <g id="Trash" transform="translate(-3.75 -2.25)">
                              <path id="Path_1012" data-name="Path 1012" d="M4.5,9h27" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                              <path id="Path_1013" data-name="Path 1013" d="M28.5,9V30a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3V9M12,9V6a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3V9" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                              <path id="Path_1014" data-name="Path 1014" d="M15,16.5v9" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                              <path id="Path_1015" data-name="Path 1015" d="M21,16.5v9" fill="none" stroke="#19a3c0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                            </g>
                          </svg>
                        </div>
                        Delete
                      </div>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div>
              <el-table
                ref="multipleTable"
                :data="resultQuery"
                style="width: 100%"
                @selection-change="checkboxChanged">
                <!-- Checkbox -->
                <el-table-column
                  type="selection">
                </el-table-column>
                <!-- Icon -->
                <el-table-column
                  label="">
                  <template slot-scope="scope">
                    <div v-if="scope.row.TYPE == 'folder'">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 26.443 22.744">
                        <g id="Group_3157" data-name="Group 3157" transform="translate(1313.87 -105.256)">
                          <path id="Path_1013" data-name="Path 1013" d="M.969.516H0A.581.581,0,0,1-.5.008.581.581,0,0,1,0-.5H.969a.552.552,0,0,1,.469.508A.552.552,0,0,1,.969.516Z" transform="translate(-1295.703 107.953)" fill="#fe9444"/>
                          <path id="Path_1013-2" data-name="Path 1013" d="M787.936,198.609V183.245c0-1.014-.721-1.17-1.773-1.17h-3.519a1.007,1.007,0,0,0-.254.013.379.379,0,0,0,.038.746,1.766,1.766,0,0,0,.255.006H786.3c.638,0,.864.222.864.851q0,7.235,0,14.47c0,.042,0,.085,0,.128-.008.291-.132.423-.418.43-.187,0-.377-.017-.562,0-.224.024-.278-.048-.278-.274q.012-5.946.006-11.892a2.2,2.2,0,0,0-.054-.608,1.434,1.434,0,0,0-1.512-1.041c-3.767,0-7.535-.012-11.3.008a1.958,1.958,0,0,1-1.868-.993,2.385,2.385,0,0,0-2.22-1.2c-1.4.013-2.8,0-4.194.007-.171,0-.248-.034-.231-.221s0-.357,0-.536a1.178,1.178,0,0,1,1.322-1.321l5.114,0a2.313,2.313,0,0,1,.606.071,1.909,1.909,0,0,1,1.091.941,2.408,2.408,0,0,0,2.185,1.172c1.364-.009,1.728,0,3.091,0a1.661,1.661,0,0,0,.179,0,.36.36,0,0,0,.353-.368.365.365,0,0,0-.332-.388,1.243,1.243,0,0,0-.23-.006h-3.142a1.625,1.625,0,0,1-1.406-.738c-.083-.119-.16-.24-.242-.36a2.3,2.3,0,0,0-1.953-1.076q-2.748-.028-5.5,0a1.9,1.9,0,0,0-1.865,1.521,5.012,5.012,0,0,0-.037,1.095c0,.159-.034.224-.209.224a1.573,1.573,0,0,0-1.734,1.351l-.041,17.082c0,.8.733,1.132,1.524,1.138q.7.005,1.406,0c.31,0,.469-.136.469-.381s-.163-.379-.471-.383c-.426,0-.852,0-1.278,0-.681,0-.926-.242-.926-.915q0-7.91-.008-15.821c0-1.025.46-1.341,1.333-1.324q2.479.048,4.96,0a1.9,1.9,0,0,1,1.826.971,2.453,2.453,0,0,0,2.287,1.222c2.8-.012,5.591,0,8.386,0,1.023,0,2.045,0,3.068,0a.739.739,0,0,1,.638.252.91.91,0,0,1,.142.607q0,7.209,0,14.417c0,.524-.085.61-.606.61l-14.964-.009a1.718,1.718,0,0,0-.305.014.369.369,0,0,0-.277.507c.092.217.282.245.489.245,5.983,0,9.237.007,15.22.007a1.137,1.137,0,0,0,1.21-1.2c.007-.349,0-.7,0-1.046,0-.593-.023-.591.589-.591C787.668,199.488,787.936,199.029,787.936,198.609Z" transform="translate(-2075.513 -74.478)" fill="#fe9444" stroke="#fe9444" stroke-width="0.3"/>
                          <path id="Path_1014" data-name="Path 1014" d="M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z" transform="translate(-1309 127)" fill="#fe9444"/>
                        </g>
                      </svg>
                    </div>
                    <div v-else-if="scope.row.NAME.includes('png') || scope.row.NAME.includes('jpg') || scope.row.NAME.includes('jpeg') || scope.row.NAME.includes('JPG') || scope.row.NAME.includes('PNG')">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="rgba(77, 207, 85, 1.0)" viewBox="0 0 512 512" width="30" height="30"><path d="M374 108H154.9l150.1-86.7c4.8-2.8 10.9-1.1 13.7 3.7l33.9 58.7c2.8 4.8 8.9 6.4 13.7 3.7 4.8-2.8 6.4-8.9 3.7-13.7l-33.9-58.7c-8.3-14.3-26.7-19.2-41-11L115.1 107.9c-0.1 0-0.1 0.1-0.2 0.1H30C13.5 108 0 121.5 0 138v344C0 498.5 13.5 512 30 512h344c16.5 0 30-13.5 30-30V138C404 121.5 390.5 108 374 108zM384 482c0 5.5-4.5 10-10 10H30c-5.5 0-10-4.5-10-10V138c0-5.5 4.5-10 10-10h344c5.5 0 10 4.5 10 10V482z"/><path d="M447.3 208.5c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C450.2 212.9 449.2 210.4 447.3 208.5z"/><path d="M508 312.9l-41.4-71.7c-2.8-4.8-8.9-6.4-13.7-3.7 -4.8 2.8-6.4 8.9-3.7 13.7l41.4 71.7c2.8 4.8 1.1 10.9-3.7 13.7l-64.3 37.1c-4.8 2.8-6.4 8.9-3.7 13.7 1.9 3.2 5.2 5 8.7 5 1.7 0 3.4-0.4 5-1.3l64.3-37.1C511.3 345.6 516.3 327.2 508 312.9z"/><path d="M263.1 158.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1s1.1 5.2 2.9 7.1 4.4 2.9 7.1 2.9c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1S264.9 160.8 263.1 158.9z"/><path d="M346 156h-39c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h29v142.6l-79.4-79.4c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-53 53c-3.9 3.9-3.9 10.2 0 14.1 3.9 3.9 10.2 3.9 14.1 0l45.9-45.9 86.4 86.4c0 0 0 0 0.1 0.1v49.2H82.1l72.6-72.6 53.9 53.9c3.9 3.9 10.2 3.9 14.1 0 3.9-3.9 3.9-10.2 0-14.1l-61-61c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-79.7 79.7V176h134c5.5 0 10-4.5 10-10 0-5.5-4.5-10-10-10H58c-5.5 0-10 4.5-10 10v240c0 5.5 4.5 10 10 10h288c5.5 0 10-4.5 10-10V166C356 160.5 351.5 156 346 156z"/><path d="M145.7 199c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32S163.3 199 145.7 199zM145.7 243c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12C157.7 237.6 152.3 243 145.7 243z"/></svg>
                    </div>
                    <div v-else-if="scope.row.NAME.includes('pdf')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 41.904 44.79">
                        <g id="pdf" transform="translate(0)">
                          <path id="Path_937" data-name="Path 937" d="M180.34,394.293H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0" transform="translate(-147.193 -359.8)" fill="#e34856"/>
                          <path id="Path_938" data-name="Path 938" d="M180.34,341.215H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0" transform="translate(-147.193 -311.365)" fill="#e34856"/>
                          <path id="Path_939" data-name="Path 939" d="M161.3,288.766a.661.661,0,0,0,.661.661h11.693a.661.661,0,1,0,0-1.322H161.966A.661.661,0,0,0,161.3,288.766Zm0,0" transform="translate(-147.194 -262.902)" fill="#e34856"/>
                          <path id="Path_940" data-name="Path 940" d="M40.124,8.672,38.932,7.378V2.751A2.758,2.758,0,0,0,36.173,0H6.6A2.758,2.758,0,0,0,3.845,2.751V7.971H2.636A2.639,2.639,0,0,0,0,10.608v8a2.639,2.639,0,0,0,2.636,2.637H3.845V39.689A2.758,2.758,0,0,0,6.6,42.44h1.51a2.683,2.683,0,0,0,2.659,2.35H39.221A2.684,2.684,0,0,0,41.9,42.111V13.555c0-2.337-.07-3.025-1.78-4.883Zm.43,3.523H35.6a1.36,1.36,0,0,1-1.36-1.356l0-5.749c.869.065,1.1.322,1.863,1.169.126.141.264.294.418.461l1.264,1.372.014.015,1.346,1.462c1.05,1.141,1.329,1.62,1.4,2.628ZM5.167,2.751A1.435,1.435,0,0,1,6.6,1.322H36.173A1.435,1.435,0,0,1,37.61,2.751V5.943l-.11-.12c-.15-.162-.284-.312-.407-.449a3.683,3.683,0,0,0-3.507-1.626H10.774a2.683,2.683,0,0,0-2.68,2.679V7.971H5.167Zm35.415,39.36a1.36,1.36,0,0,1-1.36,1.357H10.774a1.359,1.359,0,0,1-1.358-1.357v-9.58a.661.661,0,0,0-1.322,0v8.586H6.6a1.435,1.435,0,0,1-1.437-1.429V21.248H8.093V29.5a.661.661,0,0,0,1.322,0V21.248h3.432a.661.661,0,0,0,0-1.322H2.635A1.316,1.316,0,0,1,1.322,18.61v-8A1.316,1.316,0,0,1,2.635,9.293h17.41a1.317,1.317,0,0,1,1.316,1.315v8a1.317,1.317,0,0,1-1.316,1.315H15.876a.661.661,0,1,0,0,1.322h4.169a2.641,2.641,0,0,0,2.638-2.637v-8a2.641,2.641,0,0,0-2.638-2.637H9.416V6.428a1.359,1.359,0,0,1,1.358-1.357h22.15l0,5.768A2.684,2.684,0,0,0,35.6,13.517h4.98V42.111Zm0,0" fill="#e34856"/>
                          <path id="Path_941" data-name="Path 941" d="M51.83,134.637H50.247a.674.674,0,0,0-.5.2.684.684,0,0,0-.2.5v4.682a.668.668,0,0,0,.2.491.675.675,0,0,0,1.15-.475v-1.358h1.017a2.013,2.013,0,0,0,1.483-.554,2.152,2.152,0,0,0-.033-2.928,2.127,2.127,0,0,0-1.534-.567Zm.492,2.624a.775.775,0,0,1-.567.242H50.9v-1.658h.867a.75.75,0,0,1,.571.246.842.842,0,0,1,.229.6A.784.784,0,0,1,52.322,137.261Zm0,0" transform="translate(-45.213 -122.859)" fill="#e34856"/>
                          <path id="Path_942" data-name="Path 942" d="M112.9,136.312a2.606,2.606,0,0,0-.829-1.037,3.172,3.172,0,0,0-1.917-.541h-1.392a.655.655,0,0,0-.492.208.667.667,0,0,0-.2.475v4.64a.665.665,0,0,0,.192.491.741.741,0,0,0,.508.183h1.5a2.811,2.811,0,0,0,1.95-.658,3.041,3.041,0,0,0,.975-2.357,3.331,3.331,0,0,0-.3-1.4Zm-1.529,2.712a1.458,1.458,0,0,1-1.15.491h-.8v-3.557h.725a1.583,1.583,0,0,1,1.213.475,1.8,1.8,0,0,1,.446,1.283,1.906,1.906,0,0,1-.433,1.308Zm0,0" transform="translate(-98.612 -122.947)" fill="#e34856"/>
                          <path id="Path_943" data-name="Path 943" d="M177.273,140.739a.646.646,0,0,0,.479-.2.655.655,0,0,0,.2-.475v-1.791h1.284a.628.628,0,0,0,.458-.179.6.6,0,0,0,0-.866.634.634,0,0,0-.454-.179h-1.284v-1.175h1.517a.574.574,0,0,0,.433-.183.6.6,0,0,0,.175-.425.6.6,0,0,0-.179-.446.585.585,0,0,0-.429-.179h-2.184a.655.655,0,0,0-.492.208.677.677,0,0,0-.2.483v4.731a.635.635,0,0,0,.208.475.668.668,0,0,0,.475.2Zm0,0" transform="translate(-161.141 -122.862)" fill="#e34856"/>
                        </g>
                      </svg>
                    </div>
                  </template>
                </el-table-column>
                <!-- Name -->
                <el-table-column
                  label="Name"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="scope.row.SHARED_BY">
                      <el-tooltip effect="light" placement="top" :enterable="false" :visible-arrow="false">
                        <div slot="content"><span class="easternblue">Shared by</span>: {{scope.row.SHARED_BY.NAME + ' (' + scope.row.SHARED_BY.EMAIL + ')'}}</div>
                        <i class="el-icon-user"></i>
                      </el-tooltip>
                    </div>
                    <p class="line-height-2 m0" style="font-size:14px" v-if="scope.row.TYPE == 'folder'"><a class="easternblue pointer" @click="folderChange(scope.row.ID, scope.row.NAME, scope.row.PARENT_ID, '', 'in')">{{scope.row.NAME}}</a></p>
                    <p class="line-height-2 m0" style="font-size:14px" v-else>{{scope.row.NAME}}</p>
                  </template>
                </el-table-column>
                <!-- Type -->
                <el-table-column
                  label="Type">
                  <template slot-scope="scope" v-if="scope.row.TYPE != 'folder'">
                    <p v-if="scope.row.NAME.includes('png')" class="line-height-2 m0">png</p>
                    <p v-else-if="scope.row.NAME.includes('jpg')" class="line-height-2 m0">jpeg</p>
                    <p v-else-if="scope.row.NAME.includes('jpeg')" class="line-height-2 m0">jpeg</p>
                    <p v-else-if="scope.row.NAME.includes('pdf')" class="line-height-2 m0">pdf</p>
                  </template>
                </el-table-column>
                <!-- Size -->
                <el-table-column
                  label="Size">
                  <template slot-scope="scope" v-if="scope.row.TYPE != 'folder'">{{formatBytes(scope.row.SIZE)}}</template>
                </el-table-column>
                <!-- Keywords -->
                <el-table-column
                  label="Keywords">
                  <template slot-scope="scope">
                    <el-tag :key="index" v-for="(tag, index) in scope.row.TAGS" style="margin-right:4px" closable :disable-transitions="false" @close="removeKeyword(scope.row.ID, tag.ID)">
                      {{tag.DA_DK}}
                    </el-tag>
                    <el-autocomplete class="border hide" :class="'input-keyword-' + scope.row.ID" v-model="inputKeywordData[scope.$index].value" ref="saveTagInput" placeholder="Keywords" size="mini" :fetch-suggestions="querySearchFilter" @select="addKeyword(scope.row.ID, inputKeywordData[scope.$index].value, scope.$index, scope.row.TYPE)" @blur="hideInputKeyword(scope.row.ID, scope.$index)">
                    </el-autocomplete>
                    <el-tooltip effect="light" placement="top" content="Tilføj" :enterable="false">
                      <el-button class="border-none transparent p1" :class="'button-new-tag-' + scope.row.ID" size="small" @click="showInputKeyword(scope.row.ID)"><i class="h5 regular cyprus el-icon-circle-plus-outline m0"></i>
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- Date -->
                <el-table-column
                  label="Date">
                  <template slot-scope="scope">
                    {{scope.row.CREATED_AT}}
                  </template>
                </el-table-column>
                <!-- Actions -->
                 <el-table-column
                  property="operations"
                  label="Operations">
                  <template slot-scope="scope">
                    <div class="flex justify-start">
                      <!-- Image editor -->
                      <el-tooltip content="Image Editor" placement="top" effect="light" :enterable="false">
                        <el-button class="outlined-standard-button border-none p1" v-if="scope.row.TYPE != 'folder'">
                          <span><i class="el-icon-brush"></i></span>
                        </el-button>
                      </el-tooltip>
                      <!-- Preview -->
                      <el-tooltip content="Preview" placement="top" effect="light" :enterable="false">
                        <el-button class="outlined-action-button border-none p1" @click="previewFile(scope.row.DOWNLOAD_URL)" v-if="scope.row.TYPE != 'folder'">
                          <span><i class="el-icon-view"></i></span>
                        </el-button>
                      </el-tooltip>
                      <!-- Duplicate -->
                      <el-tooltip content="Duplicate" placement="top" effect="light" :enterable="false">
                        <el-button class="outlined-primary-button border-none p1" @click="loopCopyFile('single', scope.row.ID)" v-if="scope.row.TYPE != 'folder'">
                          <span><i class="el-icon-document-copy"></i></span>
                        </el-button>
                      </el-tooltip>
                      <!-- Share -->
                      <!-- <el-tooltip content="Share" placement="top" effect="light" :enterable="false">
                        <el-button class="outlined-action-button border-none p1" v-if="scope.row.TYPE == 'folder' && scope.row.SHARED_BY == null && scope.row.NAME != 'Projects'">
                          <span><i class="el-icon-share"></i></span>
                        </el-button>
                      </el-tooltip> -->
                      <!-- Rename -->
                      <el-tooltip content="Rename" placement="top" effect="light" :enterable="false">
                        <el-button class="border-none regular p1 outlined-standard-button" @click="showRenameFile('single', scope.row)" v-if="scope.row.SHARED_BY == null">
                          <span><i class="el-icon-edit"></i></span>
                        </el-button>
                      </el-tooltip>
                      <!-- Delete -->
                      <el-tooltip content="Delete" placement="top" effect="light" :enterable="false">
                        <el-button class="outlined-delete-button border-none p1" v-if="scope.row.SHARED_BY == null" @click="confirmDelete('single', scope.row.ID, scope.row.TYPE)">
                          <span><i class="el-icon-delete"></i></span>
                        </el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div>
        <!-- Create folder -->
        <b-modal id="formModal" hide-footer size="lg" centered lazy v-model="createFolderFormVisible" ref="createFolder" class="p-2 pb-4" no-close-on-backdrop no-close-on-esc>
          <div slot="modal-header" class="pt2 px0">
            <div class="clearfix">
              <div class="col-12 px2">
                <p class="h4 darkblue gibson line-height-1 semi-bold">
                  Skriv til ...
                </p>
              </div>
            </div>
          </div>
          <div></div>
          <span class="h5 bold darkblue">Opret</span>
          <div class="mb4"></div>
          <div class="clearfix" v-if="formLoading">
            <Loading></Loading>
          </div>
          <form v-else>
            <div class="form-group mb4">
              <el-input placeholder="Navn" v-model="createFolderForm.name" class="col-12 p0"></el-input>
              <div v-if="submitted && !createFolderForm.name"  class="red mt1">Nødvendig</div>
            </div>
            <div class="flex justify-end">
              <button type="button" class="col-3 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="closeCreateFolder()">
                <span>Luk</span>
              </button>
              <button type="button" class="col-3 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="addFolder()">
                <span>Indsend</span>
              </button>
            </div>
          </form>
	      </b-modal>
        <!-- Upload file -->
        <b-modal id="formModal" hide-footer size="lg" centered lazy v-model="addFileFormVisible" ref="uploadFile" class="p-2 pb-4" no-close-on-backdrop no-close-on-esc>
          <div slot="modal-header" class="pt2 px0">
            <div class="clearfix">
              <div class="col-12 px2">
                <p class="h4 darkblue gibson line-height-1 semi-bold">
                  Skriv til ...
                </p>
              </div>
            </div>
          </div>
          <div></div>
          <span class="h5 bold darkblue">Uploade</span>
          <div class="mb4"></div>
          <div class="clearfix" v-if="formLoading">
            <Loading></Loading>
          </div>
          <form v-else>
            <div class="form-group">
              <el-upload
                action="#"
                class="col-12 p0"
                :auto-upload="false"
                :drag="true"
                :multiple="true"
                :accept="acceptedFileType"
                :on-change="uploadFile">
                  <i slot="default" class="el-icon-upload easternblue"></i>
                  <div class="el-upload__text center">Drop filer her <span class="easternblue">Eller klik for at uploade</span></div>
                  <div class="el-upload__tip center easternblue">Filer mindre end 1mb</div>
                  <div slot="file" slot-scope="{file}">
                    {{file.name}}
                    <button type="button" class="transparent-button" @click="removeUpload(file)"><i class="el-icon-delete red"></i></button>
                  </div>
              </el-upload>
              <div class="red mt1" v-if="submitted && addFileForm.file.length == 0">Nødvendig</div>
            </div>
            <div class="flex justify-end">
              <button type="button" class="col-3 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="closeAddFileForm()">
                <span>Luk</span>
              </button>
              <button type="button" class="col-3 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="addFile()">
                <span>Indsend</span>
              </button>
            </div>
          </form>
	      </b-modal>
        <!-- Rename File -->
        <b-modal id="formModal" hide-footer size="lg" centered lazy v-model="renameFileFormVisible" ref="RenameFile" class="p-2 pb-4" no-close-on-backdrop no-close-on-esc>
          <div slot="modal-header" class="pt2 px0">
            <div class="clearfix">
              <div class="col-12 px2">
                <p class="h4 darkblue gibson line-height-1 semi-bold">
                  Skriv til ...
                </p>
              </div>
            </div>
          </div>
          <div></div>
          <span class="h5 bold darkblue">Omdøb</span>
          <div class="mb4"></div>
          <div class="clearfix" v-if="formLoading">
            <Loading></Loading>
          </div>
          <form v-else>
            <div class="form-group mb4" v-for="(row, index) in selectedCheckboxesData" :key="index">
              <div v-if="row.TYPE != 'folder'">
                <input placeholder="Fil" :id="row.ID + '-' + row.NAME.split('.')[1]" :value="row.NAME.split('.')[0]" class="editFile col-10 px2 py1"> <span class="pl1"><b>.</b>{{row.NAME.split('.')[1]}}</span>
              </div>
              <div v-else>
                <input placeholder="Fil" :id="row.ID + '-folder'" :value="row.NAME.split('.')[0]" class="editFile col-12 px2 py1">
              </div>
              <!-- <div v-if="submitted && !row.NAME"  class="red mt1">Nødvendig</div> -->
            </div>
            <div class="flex justify-end">
              <button type="button" class="col-3 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="closeRenameFile()">
                <span>Luk</span>
              </button>
              <button type="button" class="col-3 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="renameFile()">
                <span>Indsend</span>
              </button>
            </div>
          </form>
	      </b-modal>
      <ErrorHandler ref="errorMsg"></ErrorHandler>
    </div>
</template>

<script>
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  components: {
    Loading,
    ErrorHandler
  },
  data () {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      searchQuery: '',
      documentsData: [],
      defaultFolderId: '',
      parentFolderData: [],
      currentFolderId: '',
      currentFolderParentId: '',
      currentProjectInfo: {},
      bulkActionVisible: false,
      createFolderFormVisible: false,
      createFolderForm: {
        name: ''
      },
      submitted: false,
      acceptedFileType: '.jpg,.png,.pdf,.pptx',
      addFileFormVisible: false,
      addFileForm: {
        file: []
      },
      inputKeywordData: [],
      keywordsList: [],
      selectedCheckboxesData: [],
      renameFileFormVisible: false,
      totalSize: null
    }
  },
  created () {
    this.displayProjects()
  },
  methods: {
    displayProjects () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/projects/', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data && res.data.length > 0) {
            res.data.forEach((projectProp, projectPropIndex) => {
              if (projectProp.IS_ACTIVE === 1) {
                this.currentProjectInfo = projectProp
                this.getKeywordsList()
                this.getDefaultFolder()
              }
            })
          }
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    getKeywordsList () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/projects/tags', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          for (var i = 0; i < res.length; i++) {
            this.keywordsList.push({
              id: res[i].ID,
              value: res[i].DA_DK
            })
          }
        },
        response => {
          this.displayFiles(this.currentFolderId)
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    getDefaultFolder () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.get(process.env.BITRIXAPI + 'partner/rootFolder', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.defaultFolderId = res.data.rootFolderId
          this.currentFolderId = res.data.rootFolderId
          this.parentFolderData.push({
            folderId: this.defaultFolderId,
            folderName: 'Main'
          })
          // this.documentsData = res.children
          this.setKeywordInputValue()
          this.displayFiles(this.currentFolderId)
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    displayFiles (folderId) {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/folder/' + folderId + '/children', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.documentsData = res.data.sort(function (a, b) {
            return b.ID - a.ID
          })
          // res.data.forEach((filesProp, filesPropIndex) => {
          //   this.documentsData.push({
          //     name: filesProp.NAME,
          //     type: filesProp.TYPE,
          //     size: filesProp.SIZE,
          //     keywords: filesProp.TAGS,
          //     date: filesProp.CREATED_AT,
          //     operations: ''
          //   })
          // })
          this.setKeywordInputValue()
          this.getTotalSize()
          this.selectedCheckboxesData = []
          this.bulkActionVisible = false
          this.loading = false
          this.formLoading = false
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    checkboxChanged (selectedData) {
      this.selectedCheckboxesData = selectedData
      if (selectedData.length > 0) {
        this.bulkActionVisible = true
      } else {
        this.bulkActionVisible = false
      }
    },
    formatBytes (bytes, decimals = 0) {
      if (bytes === 0) {
        return '0 Bytes'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    customColorMethod (percentage) {
      if (percentage < 30) {
        return '#0092B9'
      } else if (percentage < 70) {
        return '#003645'
      } else {
        return '#fc000f'
      }
    },
    previewFile (fileLink) {
      window.open(fileLink)
    },
    loopCopyFile (type, id) {
      var ids = []
      if (type === 'single') {
        ids.push(id)
      } else {
        for (var i = 0; i < this.selectedCheckboxesData.length; i++) {
          if (this.selectedCheckboxesData[i]) {
            ids.push(parseInt(this.selectedCheckboxesData[i].ID))
          }
        }
      }
      var lastLoop = false
      for (var k = 0; k < ids.length; k++) {
        for (var x = 0; x < this.documentsData.length; x++) {
          if (this.documentsData[x].ID === ids[k]) {
            if (k === ids.length - 1) {
              lastLoop = true
            }
            this.copyFile(this.documentsData[x].ID, this.documentsData[x].NAME, lastLoop)
          }
        }
      }
    },
    copyFile (fileId, fileName, lastLoop) {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.post(this.$bitrixapi + 'partner/file/copy?parentId=' + this.currentFolderId + '&fileId=' + fileId, data, { headers }, { emulateJSON: true }).then(
        response => {
          if (lastLoop) {
            this.displayFiles(this.currentFolderId)
            this.$message({
              type: 'success',
              message: 'Succes'
            })
          }
        },
        response => {
          this.displayFiles(this.currentFolderId)
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    showCreateFolder () {
      this.createFolderFormVisible = true
    },
    closeCreateFolder () {
      this.submitted = false
      this.createFolderFormVisible = false
    },
    addFolder () {
      this.submitted = true
      var valid = false
      if (this.createFolderForm.name !== '') {
        valid = true
      }
      if (valid) {
        this.formLoading = true
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        var data = {
        }
        this.$http.post(this.$bitrixapi + 'partner/folder?folderName=' + this.createFolderForm.name + '&parentId=' + this.currentFolderId, data, { headers }, { emulateJSON: true }).then(
          response => {
            this.displayFiles(this.currentFolderId)
            this.$message({
              type: 'success',
              message: 'Succes'
            })
            this.clearFields()
            this.closeCreateFolder()
          },
          response => {
            var error = response.body
            this.$refs.errorMsg.showMsg(error)
          })
      }
    },
    clearFields () {
      this.createFolderForm.name = ''
      this.addFileForm.file = []
    },
    uploadFile (file, fileList) {
      this.addFileForm.file = fileList
    },
    removeUpload (file) {
      var images = this.addFileForm.file
      for (var i = 0; i < images.length; i++) {
        if (file.uid === images[i].uid) {
          images.splice(i, 1)
        }
      }
      this.addFileForm.file = images
    },
    showAddFileForm () {
      this.addFileFormVisible = true
    },
    closeAddFileForm () {
      this.submitted = false
      this.addFileFormVisible = false
    },
    addFile () {
      this.submitted = true
      var files = this.addFileForm.file
      if (files.length > 0) {
        this.formLoading = true
        var formData = new FormData()
        for (var i = 0; i < files.length; i++) {
          formData.append('files[]', files[i].raw)
        }
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        this.$http.post(this.$bitrixapi + 'partner/files?parentId=' + this.currentFolderId, formData, { headers }, { emulateJSON: true }).then(
          response => {
            this.displayFiles(this.currentFolderId)
            this.closeAddFileForm()
            this.$message({
              type: 'success',
              message: 'Succes'
            })
          },
          response => {
            this.formLoading = false
            var error = response.body
            this.$refs.errorMsg.showMsg(error)
          }
        )
      }
    },
    removeKeyword (fileId, keywordId) {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.delete(this.$bitrixapi + 'partner/file/' + fileId + '/keyword?keywordId=' + keywordId, { headers }, data, { emulateJSON: true }).then(
        response => {
          this.displayFiles(this.currentFolderId)
          this.$message({
            type: 'success',
            message: 'Succes'
          })
        },
        response => {
          this.displayFiles(this.currentFolderId)
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    showInputKeyword (fileId) {
      var input = document.querySelector('.input-keyword-' + fileId)
      var button = document.querySelector('.button-new-tag-' + fileId)
      input.classList.remove('hide')
      input.querySelector('input').focus()
      button.classList.add('hide')
    },
    hideInputKeyword (fileId, index) {
      this.inputKeywordData[index].value = null
      var input = document.querySelector('.input-keyword-' + fileId)
      var button = document.querySelector('.button-new-tag-' + fileId)
      button.classList.remove('hide')
      input.classList.add('hide')
    },
    setKeywordInputValue () {
      for (var i = 0; i < this.documentsData.length; i++) {
        this.inputKeywordData.push({
          value: null
        })
      }
    },
    addKeyword (fileId, value, index, type = '') {
      if (value) {
        var keyword = this.keywordsList.filter((property) => { return property.value === value })[0]
        this.saveInputKeyword(fileId, keyword.id, keyword.value, index, type)
      }
    },
    saveInputKeyword (fileId, keywordId, keywordName, index, type = '') {
      this.hideInputKeyword(fileId, index)
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      var filetype = 'file'
      if (type === 'folder') {
        filetype = 'folder'
      }
      this.$http.post(this.$bitrixapi + 'partner/' + filetype + '/' + fileId + '/keyword?keywordId=' + keywordId + '&keywordName=' + keywordName, data, { headers }, { emulateJSON: true }).then(
        response => {
          this.displayFiles(this.currentFolderId)
          this.$message({
            type: 'success',
            message: 'Succes'
          })
        },
        response => {
          this.displayFiles(this.currentFolderId)
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    showRenameFile (type, row) {
      if (type === 'single') {
        this.selectedCheckboxesData.push(row)
      }
      this.renameFileFormVisible = true
    },
    closeRenameFile () {
      this.selectedCheckboxesData = []
      this.submitted = false
      this.renameFileFormVisible = false
    },
    renameFile () {
      this.formLoading = true
      var fields = document.querySelectorAll('.editFile')
      var lastLoop = false
      fields.forEach((propFields, propFieldsIndex) => {
        var id = propFields.id.split('-')[0]
        var type = propFields.id.split('-')[1]
        var value = ''
        var url = ''
        var httpType = ''
        if (type !== 'folder') {
          value = propFields.value + '.' + type
          url = this.$bitrixapi + 'partner/file/rename?id=' + id + '&newName=' + value
          httpType = 'post'
        } else {
          value = propFields.value
          url = this.$bitrixapi + 'partner/folder/' + id + '?newName=' + value
          httpType = 'put'
        }
        if (propFieldsIndex === (fields.length - 1)) {
          lastLoop = true
        }
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        var data = {
        }
        this.$http[httpType](url, data, { headers }, { emulateJSON: true }).then(
          response => {
            if (lastLoop) {
              this.displayFiles(this.currentFolderId)
              this.closeRenameFile()
              this.$message({
                type: 'success',
                message: 'Succes'
              })
            }
          },
          response => {
            this.formLoading = false
            this.displayFiles(this.currentFolderId)
            var error = response.body
            this.$refs.errorMsg.showMsg(error)
          }
        )
      })
    },
    querySearchFilter (queryString, callback) {
      var data = this.keywordsList
      var results = queryString ? data.filter(this.createFilter(queryString)) : data
      callback(results)
    },
    createFilter (queryString) {
      return (data) => {
        return (data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    confirmDelete (type, fileId, fileType) {
      this.$confirm('Bekræft sletning', 'Slette', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        var lastLoop = false
        if (type === 'single') {
          lastLoop = true
          this.deleteFile(fileId, fileType, lastLoop)
        } else {
          this.selectedCheckboxesData.forEach((selectedProp, selectedPropIndex) => {
            var fileId = selectedProp.ID
            var fileType = selectedProp.TYPE
            if (selectedPropIndex === this.selectedCheckboxesData.length - 1) {
              lastLoop = true
            }
            this.deleteFile(fileId, fileType, lastLoop)
          })
        }
      }).catch(() => {
      })
    },
    deleteFile (fileId, fileType, lastLoop) {
      console.log(fileType)
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.delete(this.$bitrixapi + 'partner/' + fileType + '/' + fileId, { headers }, data, { emulateJSON: true }).then(
        response => {
          this.displayFiles(this.currentFolderId)
          if (lastLoop) {
            this.$message({
              type: 'success',
              message: 'Succes'
            })
          }
        },
        response => {
          this.displayFiles(this.currentFolderId)
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    filterFile (name) {
      this.searchQuery = name
    },
    getTotalSize () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/folder/totalsize', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.totalSize = Math.floor(parseFloat(res.data.split(' ')[0])) + ' ' + res.data.split(' ')[1]
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    folderChange (currentFolderId, currentFolderName, currentFolderParentId, index, type) {
      this.loading = true
      var folderId = ''
      this.searchQuery = ''
      if (type === 'in') {
        this.parentFolderData.push({
          folderId: currentFolderId,
          folderName: currentFolderName
        })
      } else {
        for (var i = 0; i < this.parentFolderData.length; i++) {
          if (i > index) {
            this.parentFolderData.splice(i, 1)
            i--
          }
        }
      }
      folderId = this.parentFolderData[this.parentFolderData.length - 1].folderId
      this.currentFolderId = folderId
      this.displayFiles(folderId)
    }
  },
  computed: {
    resultQuery () {
      if (this.searchQuery) {
        return this.documentsData.filter((doc) => {
          return this.searchQuery.toLowerCase().split(' ').every(v => doc.NAME.toLowerCase().includes(v))
        })
      } else {
        return this.documentsData
      }
    }
  }
}
</script>

<style>
#documents .el-input--prefix .el-input__inner {
  height: 100%;
}
#documents .el-button+.el-button {
  margin: 0;
}
#formModal .modal-dialog {
  max-width: 500px;
}
#formModal .modal-content {
  padding: 1rem;
}
#formModal .el-upload, #formModal .el-upload-dragger {
  width: 100%;
}
#documents .el-tag {
  border-radius: 0;
  text-transform: capitalize;
  border: 0;
  color: #fff;
  height: auto;
  background-color: rgb(25, 163, 192);
}
#documents .el-tag .el-tag__close {
  color: #fff;
}
#documents .el-tag .el-tag__close:hover {
  background-color: #003645;
  color: #fff;
}
#documents .breadcrumb-item a::after {
  display: none;
}
</style>


// WEBPACK FOOTER //
// documents.vue?1b33446f